import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AutoCompleteOption } from "../component/common/AutoComplete";
import FormInput from "../component/common/FormInput";
import { ContextOperation } from "../context/OperationContext";

const useTenant = () => {
  const { tenant, setTenant } = useContext(ContextOperation);

  const [options, setOptions] = useState<AutoCompleteOption[]>([]);
  useEffect(() => {
    const user: any = JSON.parse(localStorage.getItem("user") || "");
     setOptions(user?.legalEntities?.filter((element: any) => element.name !== "all")
      .map((element: any) => ({
       value: element.name,
       label: element.name,
     })));
//      setOptions([
//       {
//       value: "drivalia_it",
//       label: "drivalia_it"
//     },
//  ])
  }, []);

  useEffect(() => {
    if (options && options.length > 0) {
      setTenant(options[0].value.toString());
    }
  }, [options]);

  const resetTenant = () => {
    if (options && options.length > 0) {
      setTenant(options[0].value.toString());
    }
  }

  const setPickupTenant = (pickupTenant:string) => {
    setTenant(pickupTenant)
  }

  const TenantAutocomplete = options.length !== 1 ? (
    <Mui.Grid key={`generic-filter-box-elements-shown-tenant`} item xl={3} lg={3} md={6} xs={12}>
      <FormInput<string>
        name="tenant"
        type="select"
        options={options}
        label="Tenant"
        onChange={setTenant}
        value={tenant}
        disableClearable={true}
      />
    </Mui.Grid>
  ) : null;

//   const TenantAutocomplete = () =>
//     {
//  console.log('first', document.documentElement.parentNode)
//   return(<AutoComplete<string>
//     disableClearable
//     options={options}
//     label="Tenant"
//     onChange={setTenantValue}
//     value={tenantValue || ""}
  
//     />)
// }
        
      
    
      
   

  
   
  

  return {
    TenantAutocomplete,
    tenantOptions: options,
    resetTenant,
    setPickupTenant
  }
 
}

export default useTenant;